import axios from 'axios';

export default {
  getRegions(params = {}) {
    return axios.get('/v1/sshcf/region', { params });
  },
  getDistricts(params = {}) {
    return axios.get('/v1/sshcf/district', { params });
  },
  getHouses(params = {}) {
    return axios.get('/v1/sshcf/house', { params });
  },
  getPlants(params = {}) {
    return axios.get('/v1/sshcf/plant', { params });
  },
  getHospitals(params = {}) {
    return axios.get('/v1/sshcf/hospital', { params });
  },
  getVendors(params = {}) {
    return axios.get('/v1/sshcf/vendor', { params });
  },
  getCompanies(params = {}) {
    return axios.get('/v1/sshcf/company', { params });
  },
  getDistrictsByRegion(regionId) {
    return axios.get(`/v1/sshcf/district/region/${regionId}`);
  },
  getDistrictsManager(districtId) {
    return axios.get(`/v1/sshcf/district/${districtId}`);
  },
  getFormRequests(params = {}) {
    return axios.get('/v1/sshcf/form_requests', { params });
  },
  getFormRequestDetail(id) {
    return axios.get(`/v1/sshcf/form_request/${id}`);
  },
  getSLAReports(params = {}) {
    return axios.get('/v1/sshcf/sla-reports', { params });
  },
  getSLAReportDetail(id) {
    return axios.get(`/v1/sshcf/sla-report/${id}`);
  },
  syncData(data) {
    return axios.get(`/v1/sshcf/sync/${data}`);
  },
  copyData(data) {
    return axios.get(`/v1/sshcf/copy/${data}`);
  },
  getSponsorshipReports(params = {}) {
    return axios.get('/v1/sshcf/sponsorship-reports', { params });
  },
  getDashboard(params = {}) {
    return axios.get('/v1/sshcf/dashboard', { params });
  },
  createFormRequests(data) {
    return axios.post('/v1/sshcf/form-request', data);
  },
  updateFormRequest(formId, data) {
    return axios.put(`/v1/sshcf/form-request/${formId}/draft`, data);
  },
  publishFormRequest(formId, data) {
    return axios.put(`/v1/sshcf/form-request/${formId}/publish`, data);
  },
  uploadFile(data) {
    return axios.post('/v1/sshcf/upload', data);
  },
  getMyAccess() {
    return axios.get('/v1/sshcf/access');
  },
  login(data) {
    return axios.post('/v1/sshcf/signin', data);
  },
  saveAsDraft(data) {
    return axios.post('/v1/sshcf/form-request/draft', data);
  },
  getIONumber() {
    return axios.get('/v1/sshcf/io-number');
  },
  importUsers(data) {
    return axios.post('/v1/sshcf/user/import', data);
  },
  uploadFinalMOU(formId, data) {
    return axios.put(`/v1/sshcf/form-request/${formId}`, data);
  },
  executeFormRequest(formId, data) {
    return axios.put(`/v1/sshcf/form-request/${formId}/execute`, data);
  },
  getStatus() {
    return axios.get('/v1/sshcf/status');
  },
  importCBS(file) {
    const data = new FormData();
    data.append('file', file);
    return axios.post('/v1/sshcf/cbs/import', data);
  }
};
